import React from 'react';
import 'twin.macro';
import { useStaticQuery, graphql } from 'gatsby';

import { Container, Heading } from '../atoms';
import NewsItem from './NewsItem';

const query = graphql`
  query allNewsQuery {
    allSanityArticles {
      nodes {
        _id
        title
        articleSubtitle
        slug {
          current
        }
        featuredImage {
          asset {
            gatsbyImageData
          }
        }
      }
    }
  }
`;

const LatestPost = ({ title }) => {
  const { allSanityArticles } = useStaticQuery(query);
  const data = allSanityArticles.nodes;

  return (
    <Container>
      <Heading tw="text-center">{title}</Heading>
      <div tw="border my-6 w-40 m-auto border-black" />
      <div tw="py-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-20">
        {data.map((item) => (
          <NewsItem post={item} key={item._id} />
        ))}
      </div>
    </Container>
  );
};

export default LatestPost;
